<template>
  <div>
    <button
      class="_rfp_mctb_navigation_01_ rfp-mctb-carousel-prev-next-button"
      :aria-disabled="!canAdvanceBackward"
      :class="[
        { 'rfp-mctb-carousel-navigation--disabled': !canAdvanceBackward },
        enableRtl ? 'rfp-mctb-carousel-next' : 'rfp-mctb-carousel-previous',
      ]"
      :style="`padding: ${clickTargetSize}px; margin-right: -${clickTargetSize}px;`"
      @click="advancePage('backward')"
    >
      &#60;
    </button>
    <button
      class="_rfp_mctb_navigation_02_ rfp-mctb-carousel-prev-next-button"
      :aria-disabled="!canAdvanceForward"
      :class="[
        { 'rfp-mctb-carousel-navigation--disabled': !canAdvanceForward },
        enableRtl ? 'rfp-mctb-carousel-previous' : 'rfp-mctb-carousel-next',
      ]"
      :style="`padding: ${clickTargetSize}px; margin-left: -${clickTargetSize}px;`"
      @click="advancePage('forward')"
    >
      &#62;
    </button>
  </div>
</template>
<script>
export default {
  name: 'rfp-mctb-navigation',
  props: {
    clickTargetSize: {
      type: Number,
      default: 8,
    },
    enableRtl: {
      type: Boolean,
      default: false,
    },
    canAdvanceForward: {
      type: Boolean,
      required: true,
    },
    canAdvanceBackward: {
      type: Boolean,
      required: true,
    },
    advancePage: {
      type: Function,
      required: true,
    },
  },
};
</script>
